export default [
  {
    level: '1',
    code: 'none',
    label: 'None'
  },
  {
    level: '1',
    code: 'mild',
    label: 'Mild'
  },
  {
    level: '1',
    code: 'moderate',
    label: 'Moderate'
  },
  {
    level: '1',
    code: 'severe',
    label: 'Severe'
  },
  {
    level: '1',
    code: 'unbearable',
    label: 'Unbearable'
  }
]
